import { loadLocal, saveLocal } from '../browser/storage';
import mcli from './index';
const STORAGE_KEY = 'declined-invites';
const keyForUser = () => mcli.getUserId() || 'anonymous';
let cacheUser = null;
let cache = new Set();
const load = () => {
    const user = keyForUser();
    if (cacheUser === user)
        return cache;
    const stored = loadLocal(STORAGE_KEY) || {};
    const ids = Array.isArray(stored[user]) ? stored[user] : [];
    cache = new Set(ids);
    cacheUser = user;
    return cache;
};
const persist = () => {
    const stored = loadLocal(STORAGE_KEY) || {};
    stored[keyForUser()] = Array.from(cache);
    saveLocal(STORAGE_KEY, stored);
};
export const isInviteDeclined = (roomId) => load().has(roomId);
export const markInviteDeclined = (roomId) => {
    load().add(roomId);
    persist();
};
export const clearInviteDecision = (roomId) => {
    if (load().delete(roomId))
        persist();
};
